module.exports = __webpack_public_path__ + "media/Images/learn-the-basics-hero-image-09e3f9dbc2c32bd479383a198c2f4544.jpg";